import { z } from 'zod';
import { FlowProducedType } from '../../../flowRun/producedType.js';
import { BaseFlowBlockSchema, FlowBlockReturnTypeSchema } from '../block.js';
import { FlowBlockType } from '../type.js';
export const FlowCreateEncounterSummaryBlockConfigSchema = z.object({
    payload: z.string().min(1, { message: 'Payload is required' }),
    gsPath: z.string().min(1, { message: 'Google Storage path is required' }),
});
export const FlowCreateEncounterSummaryBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.CreateEncounterSummary),
    returnType: FlowBlockReturnTypeSchema(FlowProducedType.EncounterSummary),
    config: FlowCreateEncounterSummaryBlockConfigSchema,
});
//# sourceMappingURL=config.js.map